import {
  GET_DEFAULT_RECOMMENDATIONS,
  GET_FILTERED_RECOMMENDATIONS,
} from 'actionTypes';

const initialState = {
  isHidden: false,
  tags: [],
};

export default function filtersReducer(state = initialState, action) {
  const { type, filters } = action;
  switch (type) {
    case GET_DEFAULT_RECOMMENDATIONS:
      return initialState;
    case GET_FILTERED_RECOMMENDATIONS:
      return {
        tags: [],
        ...filters,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/filtersReducer.js